import { Box, styled } from "@mui/material";
import MuiButton from "@mui/material/Button";
import { Icon } from "../Icon";

export const LabelIconButtonWrapper = styled("span")`
  display: inline-block;
`;

export const IconStyled = styled(Icon)`
  display: flex;
`;

export const LabeledIconButtonStyled = styled(MuiButton, {
  shouldForwardProp: (prop: string) =>
    !["$isSelected", "$alignment"].includes(prop),
})<{ $isSelected?: boolean; $alignment?: "center" | "start" | "end" }>`
  display: flex;
  width: 68px;
  flex-direction: column;
  text-transform: initial;
  transition: all 0.15s;
  box-sizing: border-box;
  align-items: ${({ $alignment }) => $alignment};
  padding: ${({ theme }) => `${theme.wsc.spacing[1]}`};
  gap: ${({ theme }) => theme.wsc.spacing[0]};
  background-color: transparent;
  border: 1px solid
    ${({ $isSelected, theme }) =>
      $isSelected ? theme.wsc.palette.primary[300] : "transparent"};
  color: ${({ $isSelected, theme }) =>
    $isSelected
      ? theme.wsc.palette.primary[300]
      : theme.wsc.palette.neutral[200]};

  :hover {
    background-color: ${({ theme }) => theme.wsc.palette.neutral[700]};
    border-radius: ${({ theme }) => theme.wsc.radius.m};
  }

  &:focus,
  &:focus-visible,
  &&:focus,
  &&:focus-visible {
    outline: none;
    box-shadow: none;
  }

  :disabled {
    color: ${({ theme, $isSelected }) =>
      $isSelected
        ? theme.wsc.palette.primary[700]
        : theme.wsc.palette.neutral[400]};

    &&& span {
      color: ${({ theme, $isSelected }) =>
        $isSelected
          ? theme.wsc.palette.primary[700]
          : theme.wsc.palette.neutral[400]};
    }

    border-color: ${({ theme, $isSelected }) =>
      $isSelected ? theme.wsc.palette.primary[700] : "transparent"};
    background-color: transparent;
  }
`;

export const Label = styled(Box, {
  shouldForwardProp: (prop) => prop !== "wrapMode",
})<{ wrapMode: "wrap" | "ellipsis" }>`
  width: 100%;
  overflow: hidden;
  ${({ theme }) => theme.wsc.typography.body3};
  line-height: normal;
  white-space: ${({ wrapMode }) =>
    wrapMode === "ellipsis" ? "nowrap" : "pre-wrap"};
  text-overflow: ${({ wrapMode }) =>
    wrapMode === "ellipsis" ? "ellipsis" : "initial"};
  word-break: ${({ wrapMode }) =>
    wrapMode === "ellipsis" ? "initial" : "break-word"};
`;
